import styles from "../../styles/playerEcosystem.module.css";
import { TRASignatureEmptyState } from "../../../../design/visual";

/**
 * Career milestones in story order (newest first from projector).
 * @param {{ milestones: Array<{ id: string, title: string, detail?: string, whenLabel?: string, tone?: string }> }} props
 */
export default function MilestonesTimeline({ milestones }) {
  if (!milestones?.length) {
    return (
      <TRASignatureEmptyState
        icon="sparkles"
        title="Milestones ahead"
        description="Finish matches and unlock achievements — career moments will land here."
      />
    );
  }
  return (
    <ol className={styles.milestoneList} aria-label="Career milestones" data-share="career-milestones">
      {milestones.map((m) => (
        <li
          key={m.id}
          className={`${styles.milestoneItem} ${styles[`tone_${m.tone}`] || ""}`}
          data-share="career-milestone"
        >
          <div className={styles.activityDot} aria-hidden />
          <div>
            <p className={styles.activityTitle}>{m.title}</p>
            {m.detail ? <p className={styles.activityDetail}>{m.detail}</p> : null}
            {m.whenLabel ? <p className={styles.activityWhen}>{m.whenLabel}</p> : null}
          </div>
        </li>
      ))}
    </ol>
  );
}
